<div class="burger-menu">
  <button class="burger-button" (click)="toggleMenu()">
    <mat-icon>menu</mat-icon>
  </button>

  <div class="menu-overlay" [class.open]="isOpen" (click)="closeMenu()"></div>

  <div class="menu-content" [class.open]="isOpen">
    <div class="menu-header">
      <button class="close-button" (click)="closeMenu()">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <div class="account-switcher" [class.open]="isAccountSwitcherOpen">
      <div class="account-switcher-header">
        <mat-icon>account_circle</mat-icon>
        <span>{{ getSelectedAccountName()}}</span>
<!--        <mat-icon>{{ isAccountSwitcherOpen ? 'expand_less' : 'expand_more' }}</mat-icon>-->
      </div>
<!--      <div class="account-switcher-list" *ngIf="isAccountSwitcherOpen">-->
<!--        <div-->
<!--          class="account-switcher-item"-->
<!--          *ngFor="let session of sessions"-->
<!--          [class.active]="session.id === currentSession?.id"-->
<!--          (click)="switchSession(session)">-->
<!--          <mat-icon>account_circle</mat-icon>-->
<!--          <span>{{ getSessionName(session) }}</span>-->
<!--        </div>-->
<!--        <div class="account-switcher-item add" (click)="addAccount()">-->
<!--          <mat-icon>add</mat-icon>-->
<!--          <span>Добавить аккаунт</span>-->
<!--        </div>-->
<!--      </div>-->
    </div>


    <h5 class="menu-item" style="margin-left: 20px;margin-right: 20px;">{{ pageTitle }}</h5>

    <div class="menu-items">
      <ng-container *ngIf="currentRoute === '/events'">
        <button class="menu-item" *ngIf="isAdmin()" (click)="openCreateEventDialog(content)">
          <mat-icon>add</mat-icon>
          <span>Создать мероприятие</span>
        </button>
      </ng-container>

      <!-- Страница мероприятий -->
      <ng-container>
        <button class="menu-item" (click)="navigate('/events')">
          <mat-icon>event</mat-icon>
          <span>Все мероприятия</span>
        </button>
      </ng-container>

      <button class="menu-item" *ngIf="isAdmin()" (click)="navigate('/logs')">
        <mat-icon>history</mat-icon>
        <span>Логи</span>
      </button>

      <button class="menu-item" *ngIf="isAdmin()" (click)="navigate('/users')">
        <mat-icon>supervised_user_circle</mat-icon>
        <span>Пользователи</span>
      </button>

      <button class="menu-item" (click)="toggleFullScreen()">
        <mat-icon>{{ isFullScreen ? 'fullscreen_exit' : 'fullscreen' }}</mat-icon>
        <span>{{ isFullScreen ? 'Выйти из полноэкранного режима' : 'Полноэкранный режим' }}</span>
      </button>

      <div class="separator"></div>
      <!-- Страница участников -->
      <ng-container *ngIf="currentRoute.includes('/participants')">
        <button class="menu-item" *ngIf="isAdmin()" (click)="navigate('/events/'+eventId + '/tag-bib/')">
          <mat-icon>qr_code</mat-icon>
          <span>Tag-Bib</span>
        </button>
        <button class="menu-item" *ngIf="eventId" (click)="navigate('/events/'+eventId + '/mass-assignment')">
          <mat-icon>people</mat-icon>
          <span>Массовое присвоение</span>
        </button>
      </ng-container>

      <!-- Страница массового присвоения -->
      <ng-container *ngIf="currentRoute.includes('/mass-assignment')">
        <button class="menu-item" *ngIf="eventId" (click)="navigate('/events/'+eventId + '/participants/')">
          <mat-icon>people</mat-icon>
          <span>Участники текущего мероприятия</span>
        </button>
        <button class="menu-item" *ngIf="isAdmin() || isSuperAdmin()" (click)="navigate('/events/'+eventId + '/tag-bib/')">
          <mat-icon>qr_code</mat-icon>
          <span>Tag-Bib</span>
        </button>
      </ng-container>

      <!-- Страница tag-bib -->
      <ng-container *ngIf="currentRoute.includes('/tag-bib')">
        <button class="menu-item" *ngIf="eventId" (click)="navigate('/events/'+eventId + '/participants')">
          <mat-icon>people</mat-icon>
          <span>Участники текущего мероприятия</span>
        </button>
        <button class="menu-item" *ngIf="eventId" (click)="navigate('/events/'+eventId + '/mass-assignment')">
          <mat-icon>people</mat-icon>
          <span>Массовое присвоение</span>
        </button>
      </ng-container>
    </div>
  </div>
</div>

<ng-template #content let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Создание мероприятия</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body">
    <form [formGroup]="eventForm" (ngSubmit)="onSubmit(modal)">
      <div class="form-group">
        <label for="name">Название мероприятия *</label>
        <input type="text" id="name" formControlName="name" class="form-control">
      </div>

      <div class="form-group">
        <label for="shortName">Краткое название *</label>
        <input type="text" id="shortName" formControlName="shortName" class="form-control">
      </div>

      <div class="form-group">
        <label for="description">Описание</label>
        <textarea id="description" formControlName="description" class="form-control"></textarea>
      </div>

      <div class="form-group">
        <label for="startDate">Дата начала *</label>
        <input type="datetime-local" id="startDate" formControlName="startDate" class="form-control">
      </div>

      <div class="form-group">
        <label for="endDate">Дата окончания *</label>
        <input type="datetime-local" id="endDate" formControlName="endDate" class="form-control">
      </div>

      <div class="form-group">
        <label for="location">Тип мероприятия</label>
        <select id="location" formControlName="location" class="form-control">
          <option value="trail">Трейл</option>
          <option value="orient">Ориентирование</option>
        </select>
      </div>

      <div class="form-group">
        <div class="form-check">
          <input type="checkbox" id="published" formControlName="published" class="form-check-input">
          <label class="form-check-label" for="published">Опубликовать мероприятие</label>
        </div>
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">Отмена</button>
        <button type="submit" class="btn btn-primary" [disabled]="!eventForm.valid">Создать</button>
      </div>
    </form>
  </div>
</ng-template>
